import React from 'react';
import cn from 'classnames';

import { OFFSET } from './Loading.constants';

import { idxMap } from 'helpers/styleMapIdx';

import styles from './Loading.module.scss';

const VARIANTS = {
  centered: styles.centered,
};

const Loading = ({
  className,
  innerClassName,
  variant,
  size,
  color,
}: {
  className: any;
  innerClassName: any;
  variant: any;
  size: any;
  color: any;
}) => (
  <div
    className={cn(
      styles.loading,
      idxMap(VARIANTS as Record<string, string>, variant),
      className,
    )}
    style={{ width: size, height: size }}
  >
    <div
      className={cn(styles.inner, innerClassName)}
      style={{
        width: size - OFFSET * 2,
        height: size - OFFSET * 2,
        margin: OFFSET,
        border: `2px solid ${color}`,
        borderColor: `${color} transparent transparent transparent`,
      }}
    />
    <div
      className={cn(styles.inner, innerClassName)}
      style={{
        width: size - OFFSET * 2,
        height: size - OFFSET * 2,
        margin: OFFSET,
        border: `2px solid ${color}`,
        borderColor: `${color} transparent transparent transparent`,
      }}
    />
    <div
      className={cn(styles.inner, innerClassName)}
      style={{
        width: size - OFFSET * 2,
        height: size - OFFSET * 2,
        margin: OFFSET,
        border: `2px solid ${color}`,
        borderColor: `${color} transparent transparent transparent`,
      }}
    />
    <div
      className={cn(styles.inner, innerClassName)}
      style={{
        width: size - OFFSET * 2,
        height: size - OFFSET * 2,
        margin: OFFSET,
        border: `2px solid ${color}`,
        borderColor: `${color} transparent transparent transparent`,
      }}
    />
  </div>
);

Loading.defaultProps = {
  size: 20,
  color: 'var(--color-blue-primary)',
};

export default React.memo(Loading) as any;
